<template>
  <div>{{value}}</div>
</template>

<script>
export default {
  props: {
    modelId: {
      type: [String, Number],
      default: null
    },
    modelName: {
      type: String,
      default: null
    },
    field: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      default: null
    }
  }
};
</script>

<style>
</style>